<template>
    <div>
        <star-rating :read-only="readOnly"
                     :rating="rating"
                     :round-start-rating="false"
                     :show-rating="showRating"
                     :star-size="30"
                     @rating-selected="setRating"
        ></star-rating>

        <p v-if="quantity" v-text="Lang.get('messages.rating.course.count', { quantity: quantity })"></p>
    </div>
</template>

<script>
    import StarRating from 'vue-star-rating';

    export default {
        components: {
            StarRating
        },

        props: ['id'],

        data() {
            return {
                showRating: false,
                readOnly: false,
                rating: 0,
                quantity: 0
            }
        },

        methods: {
            setRating(rating) {
                axios.post('/ratings/course/', {
                    id: this.id,
                    rating: rating,
                }).then((response) => {
                    this.rating = response.data.meta.average;
                    this.quantity = response.data.meta.quantity;
                    this.readOnly = ! response.data.meta.canRate;
                    flash(Lang.get('messages.rating.course.success'));
                }).catch((error) => {
                    alert(error.response.data);
                });
            },
        },

        mounted() {
            axios.get('/ratings/course/' + this.id)
                .then((response) => {
                    this.rating = response.data.average;
                    this.quantity = response.data.quantity;
                    this.readOnly = ! response.data.canRate;
                });
        }
    }
</script>

<style scoped>
    @media (max-width: 991px) {
        .vue-star-rating {
            justify-content: center;
        }
    }
</style>
